<div class="flex items-center justify-center dialog-header ">
    Reset Password

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">
    <div>
        <div for="newPassword" class="font-semibold mb-2">Enter new password</div>
        <p-password id="newPassword" 
        [inputStyle]="{'border-radius': '5px !important'}"
        [style]="{'box-shadow': 'none', 'border-radius': '5px !important'}"
        class="mt-3" [(ngModel)]="newPassword" [feedback]="false" toggleMask>
        </p-password>
    </div>

    <div class="flex gap-4 mt-4">
        <p-button label="Cancel"
        
        severity="danger" variant="outlined" (click)="handleCloseDialog()"></p-button>
        <p-button label="Reset" 
        icon="pi pi-save"
        (click)="saveNewPassword()" [disabled]="isLoading" [loading]="isLoading">
        </p-button>
    </div>

</div>